import cs from './cs.json'
import da from './da.json'
import de from './de.json'
import el from './el.json'
import en from './en.json'
import enUS from './en-us.json'
import es from './es.json'
import fi from './fi.json'
import fr from './fr.json'
import hu from './hu.json'
import it from './it.json'
import ja from './ja.json'
import ko from './ko.json'
import nl from './nl.json'
import no from './no.json'
import pl from './pl.json'
import pt from './pt.json'
import ptBR from './pt-br.json'
import ro from './ro.json'
import ru from './ru.json'
import sk from './sk.json'
import sv from './sv.json'
import tr from './tr.json'
import zhCN from './zh-cn.json'
import zhHans from './zh-hans.json'
import zhHant from './zh-hant.json'
import zhTW from './zh-tw.json'

const availableLanguages = {
    cs,
    da,
    de,
    el,
    en,
    es,
    fi,
    fr,
    hu,
    it,
    ja,
    ko,
    nl,
    no,
    pl,
    pt,
    ro,
    ru,
    sk,
    sv,
    tr,
    zh: zhHans,
    'en-us': enUS,
    'pt-br': ptBR,
    'zh-cn': zhCN,
    'zh-hans': zhHans,
    'zh-hant': zhHant,
    'zh-tw': zhTW,
} as const

type availableLanguagesType = typeof availableLanguages
export type AvailableLanguages = keyof availableLanguagesType
export const availableLanguagesArray = Object.keys(availableLanguages)

export const usedTextsIds = {
    webshop_offer_voucher_correctCode: '',
    webShop_howToFindId_desc: '',
    webShop_howToFindId_link: '',
    webshop_offer_voucher_codeIsIncorrect: '',
    webshop_offer_voucher_enterYourCode: '',
    webShop_unexpectedError_desc: '',
    webShop_accountBanned_desc: '',
    webshop_confirm: '',
    webshop_termsConditions_1: '',
    webshop_purchase_privacyPolicy: '',
    webshop_legal_1: '',
    webshop_support_1: '',
    mbs_access_welcome_desc: '',
    btn_login: '',
    mbs_access_error_sessionExpired_desc: '',
}

export default availableLanguages
